"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequiredLegalVersion = getRequiredLegalVersion;
/** The version the API wants accepted, or null when the error isn't a legal-acceptance refusal. */
function getRequiredLegalVersion(error) {
    var _a;
    var legalAcceptanceRequiredCode = "LEGAL_ACCEPTANCE_REQUIRED";
    if (typeof error !== "object" || error === null || !("status" in error) || error.status !== 403 || !("data" in error)) {
        return null;
    }
    var content = (_a = error.data) === null || _a === void 0 ? void 0 : _a.content;
    return (content === null || content === void 0 ? void 0 : content.code) === legalAcceptanceRequiredCode && typeof content.version === "string" ? content.version : null;
}
